export default __webpack_public_path__ + "static/media/doubleGreenTick.a2dbeb8d.svg";